module.exports = {
    ch: '零一二三四五六七八九'
    ,ch_u: '个十百千万亿'
    ,ch_f: '负'
    ,ch_d: '点'
}


//////////////////
// WEBPACK FOOTER
// ./~/nzh/src/langs/cn_s.js
// module id = 0asM
// module chunks = 9